import React, { Component } from "react";
import { BaseLoginCard } from "../Login/BaseLoginScreen";
import * as TabuApi from "@my-dld/tabuapi";
import {
	BirthPlaceModel,
	DomesticContactModel,
	GenderModel,
	MobileNumberModel,
	NationalityModel,
	OwnerRegiModel,
	PassportInformation,
	PersonNameModel,
	populateTabuLookUp,
	RegisterTabuLookup,
	TabuCountryLookup,
	TabuLookUp
} from "@my-dld/tabuapi";
import { checkExceedLimit, DNRDModelX } from "./utils";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { toMobileX } from "../MyDLD/MyProfile";
import { IRegContext, RegContext } from "./ctx";
import _ from "lodash";
import { DataEnableEditProvider, dualValueManager, OrgDataEnableEditProvider } from "@my-dld/components/Form/FormField";
import Strings from "@my-dld/assets/strings";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { EidStateFormatter } from "../Login/owner/EID";
import FixedEidInput, { FixedMobileInput } from "@my-dld/components/FixedEidInput";
import { serverDateToDate, toServerDate } from "@eres/core/dist/DateTime";
import JqDatePicker from "@my-dld/components/JQDatePicker";
import { DateUtil, I8N, StringUtil } from "@eres/core";
import PickerInput from "@my-dld/components/Form/PickerInput";
import { navigate, replaceNavigate } from "@my-dld/utils/StoreUtils";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { DocumentUpload } from "./Documents";
import { DocumentModel, RegistrationUtils, TabuDocumentRequest } from "@10x/tabu-mobile-api";
import { trackEventWithData } from "@my-dld/utils/Analytics";

interface RegiLookupState {
	Gender: RegisterTabuLookup[];
	Countries: TabuCountryLookup[];
	Languages: RegisterTabuLookup[];
}


interface State extends RegiLookupState {
	orgData?: DNRDModelX;
	newData?: DNRDModelX;
	error: { [ k: string ]: string };
	today: Date;
}

const LookUpKeys = [ TabuLookUp.GENDER, TabuLookUp.COUNTRIES, TabuLookUp.LANGUAGES ];

export class Forms extends Component<RoutedViewProps, State> {
	static contextType = RegContext;
	context!: React.ContextType<typeof RegContext>;
	docsRef = React.createRef<DocumentUpload>();

	constructor( props: RoutedViewProps, ctx: IRegContext ) {
		super( props );
		let value = ctx.profile;
		this.state = {
			newData: {},
			Gender: [],
			Countries: [],
			Languages: [],
			error: {},
			today: new Date(),
			orgData: _.cloneDeep( value ),
		};
		if ( value == null ) {
			navigate( "/register" );
		}
	}

	componentDidMount() {
		if ( this.state.orgData ) {
			showLoading();
			this.loadLookUps( 0 );
		}
	}

	validateForm(): boolean {
		const state = {
			...this.state.orgData,
			...this.state.newData,
		} as DNRDModelX;
		const error: { [ k: string ]: string } = {};
		let isValid = true;
		isValid = checkNotEmpty( state, "NameEn", error ) && isValid;
		isValid = checkNotEmpty( state, "NameAr", error ) && isValid;
		isValid = checkNotEmpty( state, "EIDExpiryDate", error ) && isValid;
		if ( state.Gender == undefined ) {
			error.Gender = Strings.required;
			isValid = false;
		}
		if ( state.NationalityEntity == undefined ) {
			error.NationalityEntity = Strings.required;
			isValid = false;
		}
		isValid = checkNotEmpty( state, "BirthDate", error ) && isValid;
		isValid = checkNotEmpty( state, "Language", error ) && isValid;
		if ( StringUtil.isEmptyStringOrNull( state.Mobile ) || ( state.Mobile && ( toMobileX( state.Mobile ) ).length !== 12 ) ) {
			error.Mobile = Strings.invalid_mobile_number;
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( state.Email ) || ( state.Email && !StringUtil.isEmailAddress( state.Email ) ) ) {
			error.Email = Strings.invalid_email_address;
			isValid = false;
		}
		// // In Arabic, Birth Place Arabic and in english Birth place English are mandatory
		if ( I8N.isRTL() ) {
			isValid = checkNotEmpty( state, "BirthPlaceNameAr", error ) && isValid;
		} else {
			isValid = checkNotEmpty( state, "BirthPlaceNameEn", error ) && isValid;
		}
		const isPassportRequired = isPassportInfoRequired( state );
		if ( isPassportRequired ) {
			isValid = checkNotEmpty( state, "Passport", error ) && isValid;
			isValid = checkNotEmpty( state, "PassportIssuePlace", error ) && isValid;
			isValid = checkNotEmpty( state, "PassportIssueDate", error ) && isValid;
			isValid = checkNotEmpty( state, "PassportExpiryDate", error ) && isValid;

		}

		// Country code from DNRD not mapping with Lookup data. That's why added this condition
		if ( isValid ) {
			let mappedCountry = this.state.Countries.find( country => country.Identity === state.CountryId );
			if ( mappedCountry == undefined ) {
				error.NationalityEntity = Strings.required;
				isValid = false;
			}
		}
		if ( isValid ) {
			let expDate = DateUtil.parseDate( state.EIDExpiryDate ? state.EIDExpiryDate : "", "YYYY-MM-DDThh:mm:ss" );
			if ( expDate ) {
				const m = checkExceedLimit( expDate );
				if ( !m ) {
					error.EIDExpiryDate = Strings.emirates_id_expired;
				}
				isValid = m;

			}
		}
		this.setState( {
			error: error,
		} );
		return isValid;
	}

	onSubmit = () => {
		const { newData, orgData } = this.state;
		const data: DNRDModelX = {
			...orgData,
			...newData,
			Documents: undefined,
		} as any;
		if ( this.validateForm() && this.docsRef.current && this.docsRef.current?.validate() ) {
			showLoading();
			this.docsRef.current.uploadDocs().then( d => {
				const ownerModel = normalizeToRegistration( data, d );
				const apiHandler = ( response: any ) => {
					hideLoading();
					TabuApi.checkTabuRegError( response, result => {
						if ( result && result.ProcedureInstance ) {
							let procedure = result.ProcedureInstance.Identity;
							if ( procedure ) {
								let procedureIdentity = procedure._procedure_Number + "-" + procedure._procedure_Id + "-" + procedure._procedure_Year;
								trackEventWithData( "Register", "SubmitSuccess", { phone: data.Mobile } );
								replaceNavigate( "/register/success/" + procedureIdentity );
							}
						} else {
							trackEventWithData( "Register", "SubmitFailed", { phone: data.Mobile } );
							showErrorMessage( Strings.registration_fail );
						}
					}, ( errors: any, errorMessage ) => {
						trackEventWithData( "Register", "SubmitFailed", { phone: data.Mobile, message: errorMessage } );
						showErrorMessage( errorMessage );
					} );
				};
				let apiExHandler = ( reason: any ) => {
					hideLoading();
					showErrorMessage( reason );
				};
				return TabuApi.registerPerson( ownerModel ).then( apiHandler ).catch( apiExHandler );
			} ).catch( ( reason ) => {
				hideLoading();
				showErrorMessage( reason.toString() );
			} );
		}
	};

	render() {
		const state = this.state;
		const data: DNRDModelX = {
			...state.orgData,
			...state.newData,
		} as any;
		let m = undefined;
		if ( state.orgData && data.EIDExpiryDate === undefined ) {
			m = { minDate: new Date() };
		}
		const isPassportRequired = isPassportInfoRequired( data );
		return <BaseLoginCard extraClasses={ "auth-container-inner-with mb-5" } id={ "registerationFlow" }>
			<div className="auth-container-form" id="emiratesIDRegister">
				<div className="row row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-3 row-cols-sm-2 row-cols-1">
					<div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content-section">
						<div className="content-section-title">
							<span className="section-title-span">{ Strings.personal_information }</span>
						</div>
					</div>
					<div className="col">
						<TextInputField
							containerClassName={ "form-group" }
							valueManager={ dualValueManager }
							id={ "NameAr" }
							holder={ this }
							required={ true }
							label={ Strings.name_arabic }
							placeHolder={ Strings.name_arabic }
							disabled={ DataEnableEditProvider( this, "NameAr" ) }
							type={ "arabic" }
							error={ this.state.error.NameAr }/>
					</div>
					<div className="col">
						<TextInputField
							containerClassName={ "form-group" }
							valueManager={ dualValueManager }
							id={ "NameEn" }
							holder={ this }
							required={ true }
							label={ Strings.name_english }
							placeHolder={ Strings.name_english }
							disabled={ DataEnableEditProvider( this, "NameEn" ) }
							type={ "english" }
							error={ this.state.error.NameEn }/>
					</div>
					<div className="col">
						<FixedEidInput
							containerClassName={ "form-group" }
							extraInputClassName={ "field-ar" }
							valueManager={ dualValueManager }
							id={ "EmiratesId" }
							label={ Strings.emirates_id }
							holder={ this }
							stateFormatter={ EidStateFormatter }
							placeHolder={ "784-XXXX-XXXXXX-X" }
							disabled={ DataEnableEditProvider( this, "EmiratesId" ) }
							required={ true }
							error={ this.state.error.EmiratesId }/>
					</div>
					<div className="col">
						<DatePicker
							holder={ this } data={ data } valueKey={ "EIDExpiryDate" }
							label={ Strings.eid_expire_date } extraOpts={ m } required={ true }/>
					</div>
					<div className="col">
						<PickerInput
							containerClassName={ "form-group " }
							holder={ this }
							valueManager={ dualValueManager }
							label={ Strings.preferred_language }
							id={ "Language" }
							items={ this.state.Languages }
							enableEditProvider={ OrgDataEnableEditProvider }
							formatter={ ( item ) => I8N.isRTL() ? item.NameAr : item.NameEn }
							toIdentifier={ ( item ) => item.Id + "" }
							onValueChange={ ( x ) => {
								let newData = this.state.newData;
								this.setState( {
									newData: {
										...newData,
										Language: x,
										LanguageID: x?.Id,
									},
								} );
							} }
							required={ true }
							error={ this.state.error.Language }/>
					</div>
					<div className="col">
						<TextInputField
							containerClassName={ "form-group" }
							valueManager={ dualValueManager }
							id={ "BirthPlaceNameAr" }
							holder={ this }
							required={ I8N.isRTL() }
							label={ Strings.birth_place_arabic }
							placeHolder={ Strings.birth_place_arabic }
							disabled={ DataEnableEditProvider( this, "BirthPlaceNameAr" ) }
							type={ "arabic" }
							error={ this.state.error.BirthPlaceNameAr }/>
					</div>
					<div className="col">
						<TextInputField
							containerClassName={ "form-group" }
							valueManager={ dualValueManager }
							id={ "BirthPlaceNameEn" }
							holder={ this }
							required={ !I8N.isRTL() }
							label={ Strings.birth_place_english }
							disabled={ DataEnableEditProvider( this, "BirthPlaceNameEn" ) }
							placeHolder={ Strings.birth_place_english }
							type={ "english" }
							error={ this.state.error.BirthPlaceNameEn }/>
					</div>
					<div className="col">
						<FixedMobileInput
							containerClassName={ "form-group" }
							extraInputClassName={ "field-ar" }
							valueManager={ dualValueManager }
							label={ Strings.mobile_number }
							id={ "Mobile" }
							holder={ this }
							placeHolder={ "+971-5X-XXXXXXX" }
							inputClassName={ "form-control ltr-text-field" }
							required={ true }
							error={ this.state.error.Mobile }
							disabled={ true }/>
					</div>
					<div className="col">
						<TextInputField
							containerClassName={ "form-group" }
							extraInputClassName={ "field-ar" }
							valueManager={ dualValueManager }
							label={ Strings.email }
							id={ "Email" }
							holder={ this }
							placeHolder={ Strings.email }
							required={ true }
							error={ this.state.error.Email }/>
					</div>
					<div className="col">
						<TextInputField
							containerClassName={ "form-group" }
							valueManager={ dualValueManager }
							id={ "Passport" }
							holder={ this }
							required={ isPassportRequired }
							label={ Strings.passport_number }
							placeHolder={ Strings.passport_number }
							disabled={ DataEnableEditProvider( this, "Passport" ) }
							type={ "english" }
							error={ this.state.error.Passport }/>
					</div>
					<div className="col">
						<TextInputField
							containerClassName={ "form-group" }
							valueManager={ dualValueManager }
							id={ "PassportIssuePlace" }
							holder={ this }
							required={ isPassportRequired }
							label={ Strings.passport_issue_place }
							placeHolder={ Strings.passport_issue_place }
							disabled={ DataEnableEditProvider( this, "PassportIssuePlace" ) }
							error={ this.state.error.PassportIssuePlace }/>
					</div>
					<div className="col">
						<DatePicker
							holder={ this } data={ data } valueKey={ "PassportIssueDate" }
							label={ Strings.passport_issue } required={ isPassportRequired }
							extraOpts={ { maxDate: new Date() } }
						/>
					</div>
					<div className="col">
						<DatePicker
							holder={ this } data={ data } valueKey={ "PassportExpiryDate" }
							label={ Strings.passport_expiry } required={ isPassportRequired }
							extraOpts={ { minDate: new Date() } }
						/>
					</div>
				</div>
				<DocumentUpload data={ this.state.orgData! } ref={ this.docsRef }/>
				<div className="auth-footer">
					<button
						type="button" className="btn btn_style1 btn-grey me-2"
						onClick={ this.props.history.goBack }>{ Strings.cancel }</button>
					<button
						type="button" className="btn btn_style1 btn_1"
						onClick={ this.onSubmit }>{ Strings.submit }</button>
				</div>
			</div>
		</BaseLoginCard>;
	}

	private getDNRDGender( data?: RegisterTabuLookup[] ) {
		if ( this.state.orgData && data && data.length > 0 )
			return data.find( gender => gender.Id === this.state.orgData!.GenderId );
		return undefined;
	}

	private loadLookUps( index: number ) {
		if ( this.state.orgData ) {
			if ( index < LookUpKeys.length ) {
				const key = LookUpKeys[ index ];
				populateTabuLookUp( key, this, ( data?: any[] ) => {
					if ( key === TabuLookUp.GENDER ) {
						hideLoading();
						const orgData = this.state.orgData;
						if ( orgData ) {
							this.setState( {
								orgData: {
									...orgData,
									Gender: this.getDNRDGender( data ),
									CountryId: orgData.NationalityEntity ? orgData.NationalityEntity.Identity : undefined,
									IsGCCNational: orgData.NationalityEntity ? orgData.NationalityEntity.Identity === 1 : false,
									Mobile: toMobileX( orgData.Mobile ? orgData.Mobile : "" ),
								}
							} );
						}
					}
					this.loadLookUps( index + 1 );
				} );
			} else {
				hideLoading();
			}
		}

	}
}


type BH = { newData?: any, error: any };
type Holder<X extends BH> = {
	state: X, setState: ( update: any ) => any
};

type DatePickerProps<X extends BH> = {
	valueKey: keyof DNRDModelX,
	label: string,
	data: DNRDModelX,
	holder: Holder<X>,
	extraOpts?: object;
	required: boolean;
};

function DatePicker<X extends BH>( props: DatePickerProps<X> ) {
	const { valueKey, label, data, holder, extraOpts, required } = props;
	const dX = data as any;
	const val = serverDateToDate( dX[ valueKey ] ? dX[ valueKey ] : "" );
	const onDateSet = ( date: Date ) => {
		holder.setState( {
			newData: {
				...holder.state.newData,
				[ valueKey ]: toServerDate( date ),
			},
			error: {
				...holder.state.error,
				[ valueKey ]: undefined,
			}
		} as unknown as X );
	};
	return <JqDatePicker
		label={ label }
		containerClassName={ "form-group mb-4 position-relative field-style" }
		inputClassName={ "form-control dailyDate" }
		value={ val }
		onDateSet={ onDateSet }
		id={ valueKey }
		opts={ {
			changeMonth: true,
			changeYear: true,
			dateFormat: "dd/mm/yy",
			defaultDate: val,
			showOn: "both",
			buttonText: "",
			showAnim: "slideDown",
			...extraOpts,
		} }
		disable={ DataEnableEditProvider( holder, valueKey ) }
		required={ required }
		error={ holder.state.error[ valueKey ] }/>;
}

function checkNotEmpty( container: any, k: string, errors: { [ k: string ]: string } ) {
	if ( StringUtil.isEmptyStringOrNull( container[ k ] ) ) {
		errors[ k ] = Strings.required;
		return false;
	}
	return true;
}

function normalizeToRegistration( data: DNRDModelX, docs: TabuDocumentRequest[] ): OwnerRegiModel {
	let pInfo = {
		Number: data.Passport!,
		EndDate: data.PassportExpiryDate!,
		StartDate: data.PassportIssueDate!,
		IssuePlace: data.PassportIssuePlace,
	} as PassportInformation;
	if ( !StringUtil.isEmptyStringOrNull( pInfo.Number ) ) {
		pInfo.PassportType = { Identity: 1 };
	}
	let regiModel: OwnerRegiModel = {
		PassportInformation: pInfo,
	};
	let personModel: PersonNameModel = {};
	let birthPlaceModel: BirthPlaceModel = {};
	let genderModel: GenderModel = {};
	let contactModel: DomesticContactModel = {};
	let mobileModel: MobileNumberModel = {};
	let nationalityModel: NationalityModel = {};

	personModel.ArabicName = data.NameAr;
	personModel.EnglishName = data.NameEn;
	regiModel.PersonName = personModel;

	// Assign English to Arabic field and assign Arabic to English field if English is not entered
	birthPlaceModel.ArabicName = !StringUtil.isEmptyStringOrNull( data.BirthPlaceNameAr ) ? data.BirthPlaceNameAr : data.BirthPlaceNameEn;
	birthPlaceModel.EnglishName = !StringUtil.isEmptyStringOrNull( data.BirthPlaceNameEn ) ? data.BirthPlaceNameEn : data.BirthPlaceNameAr;
	regiModel.BirthPlace = birthPlaceModel;

	genderModel.Identity = data.Gender!.Id;
	genderModel.NameAr = data.Gender!.NameAr;
	genderModel.NameEn = data.Gender!.NameEn;
	regiModel.Gender = genderModel;

	let formateMobile = StringUtil.normaliseMobileNumber( data.Mobile! );
	if ( formateMobile && formateMobile.length === 12 ) {
		mobileModel.CountryCode = "971";
		mobileModel.MobileCode = formateMobile.substring( 3, 5 );
		mobileModel.MobileNumber = formateMobile.substring( 5, 12 );
		contactModel.MobileNumber = mobileModel;
		contactModel.Email = data.Email;
		regiModel.DomesticContact = contactModel;
	}

	if ( data.NationalityEntity ) {
		nationalityModel.Identity = data.NationalityEntity.Identity;
		nationalityModel.NameAr = data.NationalityEntity.NameAr;
		nationalityModel.NameEn = data.NationalityEntity.NameEn;
		regiModel.Nationality = nationalityModel;
		data.IsGCCNational = nationalityModel.Identity === 1;
	}
	regiModel.PersonType = data.IsGCCNational ? 1 : 2;
	regiModel.BirthDate = data.BirthDate!;
	regiModel.EmiratesID = data.EmiratesId;
	regiModel.EmiratesIDExpiry = data.EIDExpiryDate!;
	regiModel.PreferedContactLanguage = "" + data.Language!.Id;
	// FIXME types
	regiModel.Documents = docs as any as DocumentModel[];
	regiModel = RegistrationUtils.normaliseRegModal( regiModel as OwnerRegiModel ) as OwnerRegiModel;
	return regiModel;
}

function isPassportInfoRequired( data: Partial<DNRDModelX> ): boolean {
	let isPassportRequired = true;
	if ( data?.IsGCCNational != null ) isPassportRequired = !data.IsGCCNational;
	if ( !isPassportRequired ) {
		if ( !StringUtil.isEmptyStringOrNull( data.Passport ) ) {
			isPassportRequired = true;
		} else if ( !StringUtil.isEmptyStringOrNull( data.PassportExpiryDate ) ) {
			isPassportRequired = true;
		} else if ( !StringUtil.isEmptyStringOrNull( data.PassportIssuePlace ) ) {
			isPassportRequired = true;
		} else if ( !StringUtil.isEmptyStringOrNull( data.PassportIssueDate ) ) {
			isPassportRequired = true;
		}
	}
	return isPassportRequired;
}
